import { useState } from "react";
import { MessageSquare, Mail, Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Help = () => {
  const [copiedPhone, setCopiedPhone] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(false);

  const phoneNumber = "+18664859773";
  const displayPhone = "+1 (866) 485-9773";
  const email = "support@quietcorner.io";
  
  const smsLink = `sms:${phoneNumber}?body=Hi%20QuietCorner%20Support%20%E2%80%94%20I%20have%20a%20question.%20I%E2%80%99m%20at%3A%20____%20%28hotel%2Fvenue%29%20and%20pod%3A%20____.`;
  const mailtoLink = `mailto:${email}?subject=QuietCorner%20question&body=Hi%20QuietCorner%20Support%20%E2%80%94%20I%20have%20a%20question.%20I%E2%80%99m%20at%3A%20____%20%28hotel%2Fvenue%29%20and%20pod%3A%20____.%0A%0ABest%20contact%20number%20%28optional%29%3A%20____`;

  const copyToClipboard = async (text: string, type: 'phone' | 'email') => {
    try {
      await navigator.clipboard.writeText(text);
      if (type === 'phone') {
        setCopiedPhone(true);
        setTimeout(() => setCopiedPhone(false), 2000);
      } else {
        setCopiedEmail(true);
        setTimeout(() => setCopiedEmail(false), 2000);
      }
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      
      <main className="flex-1 flex items-center justify-center px-4 pt-24 pb-12">
        <div className="w-full max-w-md space-y-8">
          {/* Header */}
          <div className="text-center space-y-2">
            <h1 className="font-montserrat text-3xl md:text-4xl font-extrabold text-primary">
              Need help?
            </h1>
            <p className="text-muted-foreground text-lg">
              Text or email us — no booking required.
            </p>
          </div>

          {/* Primary Actions */}
          <div className="space-y-4">
            <Button
              asChild
              size="lg"
              className="w-full h-16 text-lg font-semibold gap-3"
            >
              <a href={smsLink}>
                <MessageSquare className="w-6 h-6" />
                Text support
              </a>
            </Button>

            <Button
              asChild
              size="lg"
              variant="secondary"
              className="w-full h-16 text-lg font-semibold gap-3"
            >
              <a href={mailtoLink}>
                <Mail className="w-6 h-6" />
                Email support
              </a>
            </Button>
          </div>

          {/* Manual Fallback */}
          <div className="bg-muted/50 rounded-xl p-6 space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">Text</p>
                <p className="font-medium text-foreground">{displayPhone}</p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => copyToClipboard(phoneNumber, 'phone')}
                className="gap-2"
              >
                {copiedPhone ? (
                  <>
                    <Check className="w-4 h-4 text-accent" />
                    Copied
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4" />
                    Copy
                  </>
                )}
              </Button>
            </div>

            <div className="border-t border-border" />

            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">Email</p>
                <p className="font-medium text-foreground">{email}</p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => copyToClipboard(email, 'email')}
                className="gap-2"
              >
                {copiedEmail ? (
                  <>
                    <Check className="w-4 h-4 text-accent" />
                    Copied
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4" />
                    Copy
                  </>
                )}
              </Button>
            </div>
          </div>

          {/* Helper Text */}
          <p className="text-center text-sm text-muted-foreground px-4">
            If you're in front of a pod, please include the venue and pod number if you can.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Help;
